// @flow

import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import './schedule.scss';
import AnimatedDisplayElement from '../../components/animated-element';
import * as ScheduleData from './schedule-data';

class Schedule extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedMonth: null,
      showMonthOptions: true,
      selectedPlace: null,
      selectedMonthLabel: null,
      showPlaceOptions: true,
      showPlaceQuestion: false,
      showResult: false,
      distributionMonth: '',
      distributionType: '',
    };
    this.selectMonth = this.selectMonth.bind(this);
    this.selectPlace = this.selectPlace.bind(this);
    this.removeMonth = this.removeMonth.bind(this);
    this.removePlace = this.removePlace.bind(this);
  }

  getDistributionMonth(selectedMonth, selectedPlace) {
    if (selectedMonth && selectedPlace) {
      return ScheduleData.DATA[selectedPlace][selectedMonth];
    }
    return '';
  }

  getDistributionType(selectedPlace) {
    if (selectedPlace) {
      return ScheduleData.DATA[selectedPlace].type;
    }
    return '';
  }

  selectMonth(month, monthLabel) {
    const { showPlaceOptions, selectedPlace } = this.state;
    this.setState({
      selectedMonth: month,
      selectedMonthLabel: monthLabel,
      showMonthOptions: false,
      showPlaceQuestion: true,
      showResult: !showPlaceOptions,
      showPlaceOptions,
      distributionMonth: this.getDistributionMonth(monthLabel, selectedPlace),
      distributionType: this.getDistributionType(selectedPlace),
    });
  }

  selectPlace(place) {
    const { selectedMonthLabel } = this.state;
    this.setState({
      selectedPlace: place,
      showPlaceOptions: false,
      showResult: true,
      distributionMonth: this.getDistributionMonth(selectedMonthLabel, place),
      distributionType: this.getDistributionType(place),
    });
  }

  removeMonth() {
    const { showPlaceOptions } = this.state;
    this.setState({
      showMonthOptions: true,
      showResult: false,
      showPlaceQuestion: !showPlaceOptions,
    });
  }

  removePlace() {
    const { showMonthOptions } = this.state;
    this.setState({
      showPlaceOptions: true,
      showResult: false,
      showPlaceQuestion: !showMonthOptions,
    });
  }

  renderMonthOptions() {
    return this.renderOptions(ScheduleData.MONTHS, this.selectMonth);
  }

  renderPlaceOptions() {
    return this.renderOptions(ScheduleData.PLACES, this.selectPlace);
  }

  renderOptions(options, onClickCallback) {
    return options.map(option => (
      <button
        type="button"
        key={option.value}
        className="schedule_option"
        onClick={() => onClickCallback(option.value, option.label)}
      >
        {option.label}
      </button>
    ));
  }

  render() {
    const {
      selectedMonth,
      selectedPlace,
      distributionMonth,
      distributionType,
      showPlaceQuestion,
      showResult,
      showPlaceOptions,
      showMonthOptions,
    } = this.state;
    return (
      <section className="container main-content schedule-page">
        <header className="page_header row flex-column align-items-center">
          <NavLink to="/" className="page_header__link mr-auto">
            <span className="prs-icon prs-icon-chevron-left" />
            Home
          </NavLink>
          <span className="prs-icon page-header--icon prs-icon-calendar" />
          <h1>Payment dates</h1>
        </header>
        <h2 className={classnames(
          'schedule__question',
          { open: showMonthOptions },
        )}
        >
          When was your music used?
        </h2>
        <AnimatedDisplayElement showOn={showMonthOptions}>
          <div className="schedule_options_3">
            {this.renderMonthOptions()}
          </div>
        </AnimatedDisplayElement>
        <AnimatedDisplayElement showOn={!showMonthOptions}>
          <button type="button" onClick={this.removeMonth} className="schedule__answer">
            {selectedMonth}
            {'\u00A0'}
            <span className="prs-icon prs-icon-cross" />
          </button>
        </AnimatedDisplayElement>
        {showPlaceQuestion && (
          <h2 className={classnames(
            'schedule__question',
            { open: showPlaceOptions },
          )}
          >
            Where was your music used?
          </h2>
        )}
        <AnimatedDisplayElement showOn={showPlaceQuestion && showPlaceOptions}>
          <div className="schedule_options_2">
            {this.renderPlaceOptions()}
          </div>
        </AnimatedDisplayElement>
        <AnimatedDisplayElement showOn={showPlaceQuestion && !showPlaceOptions}>
          <button type="button" onClick={this.removePlace} className="schedule__answer">
            {selectedPlace}
            {'\u00A0'}
            <span className="prs-icon prs-icon-cross" />
          </button>
        </AnimatedDisplayElement>
        <AnimatedDisplayElement showOn={showResult}>
          <div className="schedule_results">
            <p className="schedule_results--main">
              You should expect payment in the
              <strong className="lime">
                {' '}
                {distributionMonth}
                {' '}
              </strong>

              distribution
            </p>
            <h2>Type of royalty</h2>
            <p className="Camber-Md">{distributionType}</p>
            <p className="schedule_results--more-info">
              {'Please use the quoted dates as a guide. '}
              {'Refer to \'Latest info\' for changes to this schedule.'}
            </p>
          </div>
        </AnimatedDisplayElement>
        <hr />
        <footer className="addtional_links schedule-additional-links">
          <a href="https://www.prsformusic.com/royalties/royalty-payment-dates/overseas-royalty-payments" target="_blank" rel="noopener noreferrer" className="addtional_link">
            <div>
              <span className="addtional_link__icon prs-icon prs-icon-overseas" />
              <p>Overseas</p>
            </div>
          </a>
          <a href="https://www.prsformusic.com/distributionupdate" target="_blank" rel="noopener noreferrer" className="addtional_link">
            <div>
              <span className="addtional_link__icon prs-icon prs-icon-announcements" />
              <p>Latest Info</p>
            </div>
          </a>
        </footer>
      </section>
    );
  }
}

export default Schedule;
